import { useTranslation } from "react-i18next";
import { TrendingDown, TrendingUp } from "lucide-react";

export const RevenueRow = ({ row, currency }) => {
  const { t } = useTranslation();
  const up = row.growth_percent >= 0;
  const Icon = up ? TrendingUp : TrendingDown;
  return (
    <div
      className="neu-in flex flex-wrap items-center justify-between gap-3 rounded-2xl p-3"
      data-testid={`revenue-row-${row.company_id}`}
    >
      <div className="min-w-0">
        <p className="truncate text-sm font-bold">{row.name}</p>
        <p className="text-xs text-muted-foreground">
          {t(`platform.statuses.${row.status}`)} · {row.employees} {t("dashboard.employees")}
        </p>
      </div>
      <div className="flex items-center gap-5 font-mono text-xs">
        <div className="text-end">
          <p className="text-[10px] tracking-normal text-muted-foreground">{t("revenue.mrr")}</p>
          <p className="font-bold">{row.mrr} {currency}</p>
        </div>
        <div className="text-end">
          <p className="text-[10px] tracking-normal text-muted-foreground">{t("revenue.paid")}</p>
          <p className="font-bold text-primary">{row.paid_month} {currency}</p>
        </div>
        <p className={`flex items-center gap-1 font-bold ${up ? "text-success" : "text-destructive"}`}>
          <Icon className="h-3.5 w-3.5" /> {row.growth_percent}%
        </p>
      </div>
    </div>
  );
};
